import React from "react"
import PropTypes from 'prop-types';

import IconCheck from 'react-icons/lib/fa/check-circle-o';
import IconDownload from 'react-icons/lib/fa/download';
import IconVirus from 'react-icons/lib/fa/bug';
import IconBeer from 'react-icons/lib/fa/beer';

export default class EntryIcon extends React.Component {
  icons = {
    'default': IconCheck,
    'tasks.download': IconDownload,
    'tasks.virusscan': IconVirus,
    'tasks.finalize': IconBeer
  }
  render() {
    const size = '40px'
    const Tag = this.icons[this.props.icon] || this.icons['default'];
    return <Tag size={30} className={`text-${this.props.color}`}/>
  }
}

EntryIcon.propTypes = {
  icon: PropTypes.string,
};

EntryIcon.defaultProps = {
  icon: 'beer'
};


// WEBPACK FOOTER //
// ./src/components/Verification/Timeline/EntryIcon.js